import { PlanType } from '@labrav/react-components'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{
  productType?: PlanType | undefined
  isCp: boolean
}>()((theme, { productType, isCp }) => ({
  root: {
    width: '100%',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  elementsGap: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  sectionText: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
  },
  resourceRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
    marginBottom: '24px',
  },
  resourcesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  trashIcon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
    paddingTop: theme.spacing(2.25),
    width: '2%',
  },
  buttonSubText: {
    color: theme.palette.textField.main,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  widthButton: {
    width: 'fit-content',
    marginBottom: theme.spacing(1),
  },
  totalText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.textField.dark,
    marginTop: '8px',
  },
  totalTextHeading: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  border: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  titleWraper: {
    display: 'flex',
    gap: theme.spacing(4),
    width: '100%',
  },
  alignDescription: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    color: theme.palette.textField.dark,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  disabledText: {
    color: theme.palette.select.light,
    opacity: '38%',
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    width: 'fit-content',
  },
  columnName: {
    width: isCp ? '25%' : '33.3%',
  },
  columnDesc: {
    width: isCp ? '25%' : '33.3%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  columnPrice: {
    width: isCp ? '25%' : '33.3%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  BuyerPrice: {
    width: '25%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  centerAlign: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  descHeightWidth: {
    width: productType !== PlanType.SAAS_SUBSCRIPTION ? '25%' : '33.3%',
  },
  heading: {
    color: theme.palette.labraText.primary,
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '28px',
    paddingBottom: theme.spacing(2),
    width: '98%',
  },
  value: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  wordWrap: {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    maxWidth: '100%',
  },
  currency: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#6A777A',
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  toolTipIcon: {
    color: theme.palette.textField.main,
    height: theme.spacing(2),
    width: theme.spacing(2),
    padding: theme.spacing(0, 0.75),
    cursor: 'pointer',
  },
  textClass: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.15px',
    color: '#2E3132',
  },
}))
